<template>
      <v-main>
        <v-container
          class="fill-height"
          fluid
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="8"
              md="4"
            >
              <v-card class="elevation-12">
                <v-toolbar
                  color="teal darken-4"
                  dark
                  flat
                >
                  <v-toolbar-title>Forgot Password</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="yellow accent-4"
                        light
                        to='/landing'
                      >
                        <span>
                        <v-icon>mdi-home-variant</v-icon>
                        Home
                        </span>

                      </v-btn>
                    </template>
                    <span>Go Back to home page</span>
                  </v-tooltip>
                </v-toolbar>
                <v-card-text>
                  <v-form @submit.prevent>
                    <v-text-field
                      label="Email Address"
                      name="login"
                      v-model="username"
                      prepend-icon="mdi-account"
                      type="text"
                      placeholder="Enter your email address"
                      @keyup.enter="submit"
                    ></v-text-field>
                    <p class="font-italic">Procedure for resetting your password will be sent to your email account</p>
  
                  </v-form>
                  <p v-if="errorMsg" class="subtitle error-msg">{{ errorMsg }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-3" dark @click="submit">
                    <span>Submit
                    <v-icon>mdi-login</v-icon>
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-main>  
</template>

<script>
import { EventBus } from '../utils'
import { forgot_password } from '../api'
export default {
    name: "forgot_password",
    data() {
        return {
            username: "",
            errorMsg: ""
        }
    },
    methods: {
        submit: function() {
            this.errorMsg = ''
            forgot_password({email: this.username}).then(() => {
                this.$router.push('/landing')
            }).catch(() => {
                this.errorMsg = 'Invalid email'
            })
        }
    },
    mounted() {
        EventBus.$on('failedAuthentication', (msg) => {
            this.errorMsg = msg
        })
    },
    beforeDestroy() {
        EventBus.$off('failedAuthentication')
    }
}
</script>

<style scoped>
.error-msg {
  color: red;
  font-weight: bold;
}
</style>>